// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonContainer {
    display: flex; 
    flex-direction: row;
    gap: 20px;
    justify-content: center; 
    align-items: center;
    margin-top: 50px;
    margin-left: 20px;
}

.buttonContainerFillTable {
    display: flex; 
    flex-direction: row;
    gap: 20px;
    justify-content: center; 
    align-items: center;
    margin-top: 10px;
    margin-left: 20px;
}
.clearButton,
.validateButton,
.uploadButton {
    flex: 1 1 auto;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/dcFileUpload/FileUpload.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;;IAGI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".buttonContainer {\n    display: flex; \n    flex-direction: row;\n    gap: 20px;\n    justify-content: center; \n    align-items: center;\n    margin-top: 50px;\n    margin-left: 20px;\n}\n\n.buttonContainerFillTable {\n    display: flex; \n    flex-direction: row;\n    gap: 20px;\n    justify-content: center; \n    align-items: center;\n    margin-top: 10px;\n    margin-left: 20px;\n}\n.clearButton,\n.validateButton,\n.uploadButton {\n    flex: 1 1 auto;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
